const translation = {
  currentPlan: 'Plano Atual',
  upgradeBtn: {
    plain: 'Fazer Upgrade do Plano',
    encourage: 'Fazer Upgrade Agora',
    encourageShort: 'Upgrade',
  },
  viewBilling: 'Ver informações de cobrança',
  buyPermissionDeniedTip: 'Por favor, entre em contato com o administrador da sua empresa para assinar',
  plansCommon: {
    title: 'Escolha o plano que melhor atende você',
    yearlyTip: 'Receba 2 meses grátis assinando anualmente!',
    mostPopular: 'Mais Popular',
    planRange: {
      monthly: 'Mensalmente',
      yearly: 'Anualmente',
    },
    month: 'mês',
    year: 'ano',
    save: 'Economize ',
    free: 'Grátis',
    currentPlan: 'Plano Atual',
    contractOwner: 'Entre em contato com o gerente da equipe',
    startForFree: 'Comece de graça',
    getStartedWith: 'Comece com',
    contactSales: 'Fale com a equipe de Vendas',
    talkToSales: 'Fale com a equipe de Vendas',
    modelProviders: 'Fornecedores de Modelos',
    teamMembers: 'Membros da Equipe',
    buildApps: 'Construir Aplicações',
    vectorSpace: 'Espaço Vetorial',
    vectorSpaceBillingTooltip: 'Cada 1MB pode armazenar cerca de 1,2 milhão de caracteres de dados vetorizados (estimado usando OpenAI Embeddings, varia entre os modelos).',
    vectorSpaceTooltip: 'O Espaço Vetorial é o sistema de memória de longo prazo necessário para que LLMs compreendam seus dados.',
    documentProcessingPriority: 'Prioridade no Processamento de Documentos',
    documentProcessingPriorityTip: 'Para maior prioridade no processamento de documentos, faça o upgrade do seu plano.',
    documentProcessingPriorityUpgrade: 'Processe mais dados com maior precisão e velocidade.',
    priority: {
      'standard': 'Padrão',
      'priority': 'Prioridade',
      'top-priority': 'Prioridade Máxima',
    },
    logsHistory: 'Histórico de Logs',
    days: 'dias',
    unlimited: 'Ilimitado',
    support: 'Suporte',
    supportItems: {
      communityForums: 'Fóruns da Comunidade',
      emailSupport: 'Suporte por E-mail',
      priorityEmail: 'Suporte prioritário por e-mail e chat',
      logoChange: 'Mudança de logo',
      SSOAuthentication: 'Autenticação SSO',
      personalizedSupport: 'Suporte personalizado',
      dedicatedAPISupport: 'Suporte dedicado à API',
      customIntegration: 'Integração e suporte personalizados',
      ragAPIRequest: 'Solicitações API RAG',
      agentModel: 'Modelo de Agente',
      workflow: 'Fluxo de trabalho',
      llmLoadingBalancing: 'Balanceamento de carga LLM',
      bulkUpload: 'Upload em massa de documentos',
      llmLoadingBalancingTooltip: 'Adicione várias chaves de API aos modelos, efetivamente ignorando os limites de taxa da API. ',
      agentMode: 'Modo Agente',
    },
    comingSoon: 'Em breve',
    member: 'Membro',
    memberAfter: 'Membro',
    messageRequest: {
      title: 'Créditos de Mensagem',
      tooltip: 'Cotas de invocação de mensagens para vários planos usando modelos da OpenAI (exceto gpt4). Mensagens além do limite usarão sua Chave de API da OpenAI.',
      titlePerMonth: '{{count,number}} mensagens/mês',
    },
    annotatedResponse: {
      title: 'Limites de Cota de Anotação',
      tooltip: 'A edição manual e anotação de respostas oferece habilidades personalizadas de perguntas e respostas de alta qualidade para aplicativos. (Aplicável apenas em aplicativos de chat)',
    },
    ragAPIRequestTooltip: 'Refere-se ao número de chamadas de API que invocam apenas as capacidades de processamento da base de conhecimento do Dify.',
    receiptInfo: 'Somente proprietários e administradores de equipe podem se inscrever e visualizar informações de cobrança',
    customTools: 'Ferramentas personalizadas',
    documentsUploadQuota: 'Cota de upload de documentos',
    annotationQuota: 'Cota de anotação',
    contractSales: 'Entre em contato com a equipe de vendas',
    unavailable: 'Indisponível',
    priceTip: 'por espaço de trabalho/',
    apiRateLimit: 'Limite de Taxa da API',
    freeTrialTipPrefix: 'Inscreva-se e receba um',
    teamMember_one: '{{count,number}} Membro da Equipe',
    documentsRequestQuota: '{{count,number}}/min Limite de Taxa de Solicitação de Conhecimento',
    cloud: 'Serviço de Nuvem',
    teamWorkspace: '{{count,number}} Espaço de Trabalho da Equipe',
    apiRateLimitUnit: '{{count,number}}/dia',
    freeTrialTipSuffix: 'Nenhum cartão de crédito necessário',
    teamMember_other: '{{count,number}} Membros da Equipe',
    comparePlanAndFeatures: 'Compare planos e recursos',
    getStarted: 'Começar',
    annualBilling: 'Cobrança Anual',
    self: 'Auto-Hospedado',
    documentsTooltip: 'Cota sobre o número de documentos importados da Fonte de Dados do Conhecimento.',
    freeTrialTip: 'teste gratuito de 200 chamadas da OpenAI.',
    documents: '{{count,number}} Documentos de Conhecimento',
    unlimitedApiRate: 'Sem limite de taxa da API',
    apiRateLimitTooltip: 'O limite da taxa da API se aplica a todas as solicitações feitas através da API Dify, incluindo geração de texto, conversas de chat, execuções de fluxo de trabalho e processamento de documentos.',
    documentsRequestQuotaTooltip: 'Especifica o número total de ações que um espaço de trabalho pode realizar por minuto dentro da base de conhecimento, incluindo criação, exclusão, atualizações de conjuntos de dados, uploads de documentos, modificações, arquivamento e consultas à base de conhecimento. Esse métrica é utilizada para avaliar o desempenho das solicitações à base de conhecimento. Por exemplo, se um usuário do Sandbox realizar 10 testes de impacto consecutivos dentro de um minuto, seu espaço de trabalho ficará temporariamente restrito de realizar as seguintes ações no minuto seguinte: criação, exclusão, atualizações de conjuntos de dados e uploads ou modificações de documentos.',
  },
  plans: {
    sandbox: {
      name: 'Sandbox',
      description: '200 vezes GPT de teste gratuito',
      includesTitle: 'Inclui:',
      for: 'Teste gratuito das capacidades principais',
    },
    professional: {
      name: 'Profissional',
      description: 'Para indivíduos e pequenas equipes desbloquearem mais poder de forma acessível.',
      includesTitle: 'Tudo no plano gratuito, além de:',
      for: 'Para Desenvolvedores Independentes/Pequenas Equipes',
    },
    team: {
      name: 'Equipe',
      description: 'Colabore sem limites e aproveite o desempenho de primeira linha.',
      includesTitle: 'Tudo no plano Profissional, além de:',
      for: 'Para Equipes de Médio Porte',
    },
    enterprise: {
      name: 'Empresa',
      description: 'Obtenha capacidades completas e suporte para sistemas críticos em larga escala.',
      includesTitle: 'Tudo no plano Equipe, além de:',
      features: {
        6: 'Segurança e Controles Avançados',
        7: 'Atualizações e Manutenção por Dify Oficialmente',
        5: 'Acordos de Nível de Serviço negociados pelos Parceiros Dify',
        1: 'Autorização de Licença Comercial',
        8: 'Suporte Técnico Profissional',
        4: 'SSO',
        2: 'Recursos Exclusivos da Empresa',
        3: 'Múltiplos Espaços de Trabalho e Gestão Empresarial',
        0: 'Soluções de Implantação Escaláveis de Nível Empresarial',
      },
      btnText: 'Contate Vendas',
      priceTip: 'Faturamento Anual Apenas',
      price: 'Custom',
      for: 'Para equipes de grande porte',
    },
    community: {
      features: {
        1: 'Espaço de Trabalho Único',
        0: 'Todos os recursos principais lançados sob o repositório público',
        2: 'Cumpre a Licença de Código Aberto Dify',
      },
      name: 'Comunidade',
      description: 'Para Usuários Individuais, Pequenas Equipes ou Projetos Não Comerciais',
      includesTitle: 'Recursos Gratuitos:',
      btnText: 'Comece com a Comunidade',
      price: 'Grátis',
      for: 'Para Usuários Individuais, Pequenas Equipes ou Projetos Não Comerciais',
    },
    premium: {
      features: {
        1: 'Espaço de Trabalho Único',
        3: 'Suporte prioritário por e-mail e chat',
        2: 'Customização de Logo e Branding do WebApp',
        0: 'Confiabilidade autogerenciada por vários provedores de nuvem',
      },
      includesTitle: 'Tudo da Comunidade, além de:',
      for: 'Para organizações e equipes de médio porte',
      price: 'Escalável',
      name: 'Premium',
      comingSoon: 'Suporte da Microsoft Azure e Google Cloud em breve',
      priceTip: 'Baseado no Mercado de Nuvem',
      btnText: 'Obtenha Premium em',
      description: 'Para organizações e equipes de médio porte',
    },
  },
  vectorSpace: {
    fullTip: 'O Espaço Vetorial está cheio.',
    fullSolution: 'Faça o upgrade do seu plano para obter mais espaço.',
  },
  apps: {
    fullTipLine1: 'Faça o upgrade do seu plano para',
    fullTipLine2: 'construir mais aplicativos.',
    fullTip1: 'Atualize para criar mais aplicativos',
    fullTip2: 'Limite do plano alcançado',
    fullTip1des: 'Você atingiu o limite de criar aplicativos neste plano.',
    contactUs: 'Contate-nos',
    fullTip2des: 'É recomendado limpar aplicações inativas para liberar uso ou entrar em contato conosco.',
  },
  annotatedResponse: {
    fullTipLine1: 'Faça o upgrade do seu plano para',
    fullTipLine2: 'anotar mais conversas.',
    quotaTitle: 'Cota de Respostas Anotadas',
  },
  usagePage: {
    documentsUploadQuota: 'Cota de Upload de Documentos',
    annotationQuota: 'Cota de Anotação',
    teamMembers: 'Membros da equipe',
    vectorSpace: 'Armazenamento de Dados do Conhecimento',
    vectorSpaceTooltip: 'Documentos com o modo de indexação de Alta Qualidade consumirã recursos de Armazenamento de Dados de Conhecimento. Quando o Armazenamento de Dados de Conhecimento atingir o limite, novos documentos não serão carregados.',
    buildApps: 'Desenvolver Apps',
  },
  teamMembers: 'Membros da equipe',
}

export default translation
